export default "__VITE_ASSET__cljNdUcF__"